export default {
  // 标题
  transfer: "转账",

  // 高级选项
  advancedOpen: "高级 >>",
  advancedClose: "高级 <<",

  // 表单标签
  transferDirection: "划转方向",
  transactionQuantity: "交易数量",
  currency: "币种",
  occurrenceTime: "发生时间",

  // 占位符
  pleaseSelectTransferDirection: "请选择转账方向",
  pleaseEnterCurrency: "请输入币种",
  startDate: "开始日期",
  endDate: "结束日期",

  // 转账方向选项
  inflow: "流入",
  outflow: "流出",
  bidirectional: "双向",

  // 按钮
  cancel: "取消",
  save: "保存",

  // 消息提示
  saveSuccess: "保存成功",

  // 时间分隔符
  to: "至",
};
